<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="fill-height">
    <v-row class="flex-child fill-height" style="max-width: none;">
      <v-col cols="12" md="3">
        <v-sheet class="fill-height" elevation="2">
          <v-row>
            <v-col cols="12" md="4">
              <v-chip class="ma-2 Headline" color="primary">
                <!-- //组织预览 -->
                {{ $vuetify.lang.t('$vuetify.custom.org.orgPreview') }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row align="center" class="my-4" justify="center">
            <v-col cols="12" md="10">
              <e-tree :active="active" :overlay="overlay" :open="openData" :items="items" :openOnClick="openOnClick" @selectedVal="selectOrg"></e-tree>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet class="fill-height" elevation="2">
          <v-row>
            <v-col cols="12" md="4">
              <v-chip class="ma-2 Headline" color="success">
                {{ $vuetify.lang.t('$vuetify.custom.org.orgOperation') }}
              </v-chip>

              <v-chip class="ma-2 Headline float-right" color="error" v-if="!saveDisabled" @click="rollbackItem">
                <v-icon>mdi-backup-restore</v-icon>
                {{label.cancelOperation}}
              </v-chip>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-card>
                <v-form ref="form">
                  <v-container fluid class="fill-height">
                    <v-row>
                      <v-col>
                        <v-text-field :disabled="textDisabled" :rules="[rules.required]" hide-details :label="label.name"
                          v-model="formData.name"/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field :disabled="textDisabled" :rules="[rules.required]" hide-details :label="label.code"
                          v-model="formData.code" />
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field :disabled="textDisabled" :rules="orgRules" :label="label.order"
                                          v-model="formData.orgOrder" />
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row justify="center">
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="primary" @click="updateItem">
                            <v-icon dark>mdi-pencil</v-icon>
                            {{label.update}}
                          </v-btn>
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="error" @click="deleteOrg">
                            <v-icon dark>mdi-delete</v-icon>
                            {{label.delete}}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-row justify="center">
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="success" @click="addOrgBtn()">
                            <v-icon dark>mdi-plus-thick</v-icon>
                            {{label.add}}
                          </v-btn>
                          <v-btn class="mx-2" :disabled="buttonsDisabled" large color="success" @click="addSubBtn()">
                            <v-icon dark>mdi-plus-thick</v-icon>
                            {{label.addSub}}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-row v-if="!textDisabled">
                  <v-col cols="12">
                    <v-tabs grow v-model="formData.iconType" @change="iconTypeChange">
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab href="#0">{{label.icon}}</v-tab>
                      <v-tab href="#1">{{label.img}}</v-tab>
                      <v-tab-item value="0">
                          <v-card>
                              <icon-selector :height="200" @change="iconChange" v-model.lazy="formData.icon"></icon-selector>
                          </v-card>
                      </v-tab-item>
                      <v-tab-item value="1">
                          <v-card height="300">
                              <v-container fluid class="fill-height">
                                  <v-row justify="center">
                                      <v-avatar size="128px">
                                          <img :src="iconShow(formData.icon)">
                                      </v-avatar>
                                  </v-row>
                                  <v-row justify="center">
                                      <v-col md="6">
                                          <v-file-input accept="image/*" v-model="file" @change="fileChange" :label="label.file"></v-file-input>
                                      </v-col>
                                  </v-row>
                              </v-container>
                          </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-btn class="mb-3" large width="90%" :disabled="saveDisabled" color="success" @click="saveItem">{{label.save}}</v-btn>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<style></style>
<script>
  import IconSelector from '@/components/icon/IconSelector'
  import ETree from '@/components/tree/ETree'
  import Mock from 'mockjs'

  export default {
    data() {
      return {
        //文本操作状态   可用作图标的显示
        textDisabled: true,
        //操作区按钮
        buttonsDisabled: true,
        //保存按钮
        saveDisabled: true,

        //是修改还是添加
        isUpdate: true,

        label: {
          name: this.$vuetify.lang.t('$vuetify.custom.org.orgName'),//'组织名称',
          code: this.$vuetify.lang.t('$vuetify.custom.org.orgCode'),//'组织编码',
          order: this.$vuetify.lang.t('$vuetify.custom.org.orgOrder'),//'组织排序码',
          update: this.$vuetify.lang.t('$vuetify.custom.org.updateOrg'),//'修改组织',
          delete: this.$vuetify.lang.t('$vuetify.custom.org.deleteOrg'),//'删除组织',
          add: this.$vuetify.lang.t('$vuetify.custom.org.addPeer'),//'新增同级',
          addSub: this.$vuetify.lang.t('$vuetify.custom.org.addSubset'),//'新增子集',
          icon: this.$vuetify.lang.t('$vuetify.custom.icon'),//'图标',
          img: this.$vuetify.lang.t('$vuetify.custom.image'),//'图片',
          save: this.$vuetify.lang.t('$vuetify.custom.preservation'),//'保存',
          cancel: this.$vuetify.lang.t('$vuetify.custom.cancelBtn'),//'取消',
          file: this.$vuetify.lang.t('$vuetify.custom.pleaseSelectImageFile'),//'请选择图像文件',
          addMenu: this.$vuetify.lang.t('$vuetify.custom.menu.menuOperation'),//'菜单操作',
          cancelOperation: this.$vuetify.lang.t('$vuetify.custom.giveUpOperation'),//'放弃操作'
          updateSuccess:this.$vuetify.lang.t('$vuetify.custom.updateSuccess'),//修改成功
          addSuccess:this.$vuetify.lang.t('$vuetify.custom.addSuccess'),//添加成功
        },
        items: [],
        itemsOld: [],
        formData: {
          id: '',
          name: '',
          code: '',
          orgOrder: '',
          icon: '',
          iconType: '',
          pid: '',
          peerId: '',
        },
        rules: {
            required: value => !!value || this.$vuetify.lang.t('$vuetify.custom.pleaseEnery')
        },
        orgRules:[ value => (!!value && value<= 9999 && value >= 0) || this.$vuetify.lang.t('$vuetify.custom.org.orgOrderDesc')],

        file: {},

        openOnClick:false,
        overlay:false,
        active:[],
        result:[],
        openData:[],
        preIcon:'',
      }
    },

    created() {
      this.loadOrganization();
    },
    mounted() {
    },
    computed: {
        iconShow(icon){
            return function(icon) {
                if (icon.length == 32) {
                    return this.$file.fileDownload(icon)
                }
                return icon
            }
        },
    },
    methods: {
      iconTypeChange(iconType) {
          this.formData.icon = this.preIcon;
          if(this.preIcon.length ==32 && iconType == "0"){
              this.formData.icon = ''
          }
          this.formData.iconType = iconType;
      },
      iconChange() {
        // this.changeItem()
      },
      fileChange(file) {
        let reader = new FileReader();
        let vueMe = this;
        reader.addEventListener("load", function() {
          let src = reader.result;
          vueMe.formData.icon = src;
          vueMe.changeItem()
        }, false);
        reader.readAsDataURL(file);
      },
      rollbackItem() {
        this.formData = {
          id: '',
          name: '',
          code: '',
          orgOrder: '',
          icon: '',
          iconType: '',
          pid: '',
          peerId: '',
        }
        this.loadOrganization();
        this.reloadStatus()
      },
      updateItem() {
        this.isUpdate = true
        this.updateButtonStatus()
      },
      addOrgBtn() {
        this.isUpdate = false
        this.updateButtonStatus()
        let id = new Date().getTime()
        let item = this.items
        for (let index of this.$utils.treeUtil.findSubscriptDefault(this.items, this.formData.peerId)) {
            if (item.children) {
                item = item['children'][index]
            } else {
                item = item[index]
            }
        }

        let parentItem = this.items
        for (let index of this.$utils.treeUtil.findSubscriptDefault(this.items, item.pid)) {
            if (parentItem.children) {
                parentItem = parentItem['children'][index]
            } else {
                parentItem = parentItem[index]
            }
        }
        this.formData.ifChild = false
        this.pushItem(parentItem, id)
      },
      addSubBtn() {
        this.isUpdate = false
        this.updateButtonStatus()
        let id = new Date().getTime()
        let item = this.items
        for (let index of this.$utils.treeUtil.findSubscriptDefault(this.items, this.formData.peerId)) {
            if (item.children) {
                item = item['children'][index]
            } else {
                item = item[index]
            }
        }
        this.formData.ifChild = true
        this.pushItem(item, id)

      },
      async saveItem() {
        if (this.$refs.form.validate()) {
          let icon
          if (this.formData.iconType === '1') {
            let from1 = new FormData();
            from1.append("filePath", "menu");
            from1.append('file', this.file);
            let file = await this.$file.fileUpload(from1)
            icon = file.fileId
          } else {
            icon = this.formData.icon
          }
          this.formData.icon = icon
          if( this.isUpdate){
              this.$api.sysOrganization.updateOrg(this.formData).then(data => {
                  if (data.flag) {
                      this.$dialog.alert(this.label.updateSuccess);
                      this.loadOrganization()
                      this.reloadStatus()
                  }
              })
          }else {
              console.log(this.formData.id);
              this.$api.sysOrganization.addOrg(this.formData).then(data => {
                  if (data.flag) {
                      this.$dialog.alert(this.label.addSuccess);
                      this.loadOrganization()
                      this.reloadStatus()
                  }
              })
          }

        }
      },
      deleteOrg() {
        let text = this.$vuetify.lang.t('$vuetify.custom.org.canYouSureDeleteOrg')
        this.$dialog.confirm(text,'提示', () => {
          this.$api.sysOrganization.deleteOrg(
            this.formData.id
          ).then(data => {
            if (data.flag) {
              this.loadOrganization()
              this.result = [];
              this.reloadStatus()
            }else{
              this.$dialog.alert(data.msg);
            }
          })
        })
      },
      /**
       * 下面的是公共方法
       */
      //查找元素所在位置
      findItem() {
        let num = -1
        let subNum = -1
        for (let i = 0; i < this.items.length; i++) {
          if (this.formData.id === this.items[i].id) {
            num = i
            break
          }
          if (this.items[i].items) {
            for (let j = 0; j < this.items[i].items.length; j++) {
              if (this.formData.id === this.items[i].items[j].id) {
                num = i
                subNum = j
                break
              }
            }
            if (subNum != -1) {
              break
            }
          }
        }
        return {
          num: num,
          subNum: subNum
        }
      },
      //更改预览实时显示
      changeItem() {
        let fit = this.findItem()
        if (fit.num != -1) {
          let item = this.items[fit.num];
          if (fit.subNum != -1) {
            let subArray = item.items;
            subArray.splice(fit.subNum, 1, {
              id: this.formData.id,
              name: this.formData.name,
              icon: this.formData.icon,
              iconType: this.formData.iconType,
            })
            item.items = subArray
          } else {
            item.name = this.formData.name
            item.icon = this.formData.icon
            item.iconType = this.formData.iconType
          }
          this.items.splice(fit.num, 1, item)
        }
      },
      //状态重置
      reloadStatus() {
        this.textDisabled = true
        this.buttonsDisabled = true
        this.saveDisabled = true
        this.overlay = false
        this.active = []
      },
      //操作区按钮点击后状态
      updateButtonStatus() {
        this.buttonsDisabled = true
        this.textDisabled = false
        this.saveDisabled = false
        this.overlay = true
      },
      //新增默认值
      pushItem(arr, id) {
        arr.children.push({
          id: id,
          name: '',
          icon: 'mdi-book-account',
          iconType: '0',
          code: '',
          orgOrder: '',
        })
        this.formData.id = id
        this.formData.name = ''
        this.formData.icon = 'mdi-book-account'
        this.formData.iconType = '0'
        this.formData.code = ''
        this.formData.orgOrder = ''

      },

      loadOrganization(){
        this.$api.sysOrganization.selectOrganization().then(data => {
          this.items = data.data
          this.setChildShow(this.items);
          // this.itemsOld = this.$utils.arrayUtil.deepClone(this.items);

        })
      },

      setChildShow(items){
          for (let i in items) {
              if (items[i].children.length == 0) {
                  items[i].children = undefined
              } else {
                  this.setChildShow(items[i].children);
              }
          }
      },

      selectOrg(val){
          let item = this.items
          for (let index of this.$utils.treeUtil.findSubscriptDefault(this.items, val[0])) {
              if (item.children) {
                  item = item['children'][index]
              } else {
                  item = item[index]
              }
          }
          this.buttonsDisabled = false
          this.formData.name = item.name
          this.formData.code = item.code
          this.formData.icon = item.icon
          this.formData.iconType = item.iconType+""
          this.preIcon = item.icon
          this.formData.orgOrder = item.orgOrder
          this.formData.id = val[0]
          this.formData.peerId = val[0]
      },
    },
    components: {
      IconSelector,
      ETree
    },
  }
</script>
